module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0149.jpg?v=4ee2aea6";